<ng-template #deptHeaderTemplate>
  <div class="grid-content-row grid-row" *ngIf="buAccess && uiDeptSettings" id="row-999">

    <div class="grid-col-dept-dummy grid-item-checkbox grid-col-frozen">
      <div class="grid-itm grid-item-rowcheckbox">

      </div>
    </div>
    <div class="grid-col grid-col-addTimecard grid-col-frozen">
      <div class="item-title grid-itm">
        <button type="submit"
                authenticate-user="Timecard.Create"
                authenticate-command="hide"
                class="btn btn-primary grid-btn-add-timecard paytransaction-btncls"
                (click)="addNewTimecard()">
          Add Timecard
        </button>
        <!--authenticate-user="TimecardImport.Create"
         authenticate-command="hide"-->
        <button type="submit"
                 authenticate-user="TimecardImport.Create"
                authenticate-command="hide"
                class="btn btn-primary grid-btn-import-timecard paytransaction-btncls"
                (click)="importNewTimecard()">
          Import Timecard
        </button>
      </div>
    </div>

    <ng-container *ngIf="buAccess.department === 'SUBMITTER' || hasTalentDepartment || hasFinanceDepartment || hasPayrollDepartment">

      <div class="grid-col-dept-dummy grid-col-dept-dummy-emp-type ops-dept-bar ops-collapsed-bar"
           [ngClass]="!uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
        <div class=" grid-itm">
        </div>
      </div>      
      <ng-container>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-emp-type operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-emp-type operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-emp-type operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
          <div class="grid-itm padding-top">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll networks-list operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll employee-type-list operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll workState-list operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy payroll-custom-rate operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy hours-worked operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll company-code operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-emp-type operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll grid-col-dept-dummy-120 operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll operation-dept-bar"
             [ngClass]="uiDeptSettings.isOperationDeptExpanded?'':'d-none'">
          <div [class.d-none]="buAccess.department == 'SUBMITTER'"
               class="pull-right grid-itm operation-actions timesheet-col-collapse">
            <i class=" fa fa-minus-square-o btn-ops-dept-collapse"
               (click)="collapseDeptColumns('SUBMITTER')">
            </i>
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll operation-dept-bar"
             [class.d-none]="buAccess.department !== 'SUBMITTER' || !uiDeptSettings.isOperationDeptExpanded">
          <div class="pull-right grid-itm operation-actions timesheet-col-collapse">
            <i class="fa fa-minus-square-o btn-ops-dept-collapse"
               (click)="collapseDeptColumns('SUBMITTER')">
            </i>
          </div>
        </div>
      </ng-container>
    </ng-container>


    <ng-container *ngIf="buAccess.department !== 'SUBMITTER'">
      <div [class.d-none]="uiDeptSettings.isTalentDeptExpanded || !hasTalentDepartment"
           class="grid-col-dept-dummy grid-col-dept-dummy-emp-type talent-dept-bar talnt-collapsed-bar">
        <div class=" grid-itm">
        </div>
      </div>
      <ng-container>
        <div [class.d-none]="!uiDeptSettings.isTalentDeptExpanded || !hasTalentDepartment"
             class="grid-col-dept-dummy grid-col-dept-dummy-scroll talent-dept-bar">
          <div class="pull-right grid-itm talent-comments timesheet-col-collapse">
            <i class="fa fa-minus-square-o btn-talnt-dept-collapse"
               [ngClass]="buAccess.department === 'APPROVER'?'d-none':''"
               (click)="collapseDeptColumns('APPROVER')">
            </i>
          </div>
        </div>
        <div [class.d-none]="!uiDeptSettings.isTalentDeptExpanded || buAccess.department !== 'APPROVER' || !hasTalentDepartment"
             class="grid-col-dept-dummy grid-col-dept-dummy-scroll talent-dept-bar">
          <div class="pull-right grid-itm talent-actions timesheet-col-collapse">
            <i class=" fa fa-minus-square-o btn-talnt-dept-collapse"
               (click)="collapseDeptColumns('APPROVER')">
            </i>
          </div>
        </div>
      </ng-container>

      <div class="grid-col-dept-dummy grid-col-dept-dummy-emp-type finDept-bar fin-collapsed-bar"
           [ngClass]="!uiDeptSettings.isFinanceDeptExpanded?'':'d-none'">
        <div class=" grid-itm">

        </div>
      </div>

      <ng-container *ngIf="uiDeptSettings.isFinanceDeptExpanded">
        <div class="grid-col-dept-dummy finance-aftra-custom-percentage finDept-bar"
             [ngClass]="uiDeptSettings.isFinanceDeptExpanded?'':'d-none'">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy finance-aftra-custom-amount finDept-bar"
             [ngClass]="uiDeptSettings.isFinanceDeptExpanded?'':'d-none'">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll finDept-bar"
             [ngClass]="uiDeptSettings.isFinanceDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>       
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll finDept-bar"
             [ngClass]="uiDeptSettings.isFinanceDeptExpanded?'':'d-none'">
          <div [class.d-none]="buAccess.department == 'FINANCE'"
               class="pull-right grid-itm finance-comments timesheet-col-collapse">
            <i class="fa fa-minus-square-o btn-fin-dept-collapse"
               (click)="collapseDeptColumns('FINANCE')">
            </i>
          </div>
        </div>
        <div [class.d-none]="!uiDeptSettings.isFinanceDeptExpanded || buAccess.department !== 'FINANCE'"
             class="grid-col-dept-dummy grid-col-dept-dummy-scroll finDept-bar">
          <div class="pull-right grid-itm finance-action timesheet-col-collapse">
            <i class=" fa fa-minus-square-o btn-fin-dept-collapse"
               (click)="collapseDeptColumns('FINANCE')">
            </i>
          </div>
        </div>

      </ng-container>


      <div class="grid-col-dept-dummy grid-col-dept-dummy-emp-type payDept-collapsed-bar"
           [ngClass]="!uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
        <div class=" grid-itm">
        </div>
      </div>

      <ng-container *ngIf="uiDeptSettings.isPayrollDeptExpanded">
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded  || uiDeptSettings.isOperationDeptExpanded">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy payroll-custom-rate payrollDept-bar hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded  || uiDeptSettings.isOperationDeptExpanded">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy hours-worked payrollDept-bar hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded  || uiDeptSettings.isOperationDeptExpanded">
          <div class=" grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded  || uiDeptSettings.isOperationDeptExpanded">
          <div class="grid-itm">
          </div>
        </div>

        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll grid-col-dept-dummy-200 payrollDept-bar hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded  || uiDeptSettings.isOperationDeptExpanded">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar hideOnOperationExpand"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded  || uiDeptSettings.isOperationDeptExpanded">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar" [ngClass]="uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar" [ngClass]="uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar" [ngClass]="uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payroll-pay-transactions payrollDept-bar" [ngClass]="uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payroll-job-code text-center payrollDept-bar" [ngClass]="uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar" [ngClass]="uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
          <div class="grid-itm">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar" [ngClass]="uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
          <div class="grid-itm payroll-comments">
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-emp-type payrollDept-bar"
             [ngClass]="uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
          <div class="pull-right grid-itm timesheet-col-collapse" [class.d-none]="buAccess.department === 'PAYROLL'">
            <i class="fa fa-minus-square-o btn-pay-dept-collapse"
               (click)="collapseDeptColumns('PAYROLL')">
            </i>
          </div>
        </div>
        <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar"
             [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || buAccess.department !== 'PAYROLL'">
          <div class="pull-right grid-itm payroll-action timesheet-col-collapse">
            <i class=" fa fa-minus-square-o btn-pay-dept-collapse"
               (click)="collapseDeptColumns('PAYROLL')">
            </i>
          </div>
        </div>
        <!--<div class="grid-col-dept-dummy grid-col-dept-dummy-emp-type payrollDept-bar"
       [ngClass]="uiDeptSettings.isPayrollDeptExpanded?'':'d-none'">
    <div
         class="pull-right grid-itm timesheet-col-collapse">
      <i class="fa fa-minus-square-o btn-pay-dept-collapse"
         (click)="collapseDeptColumns('PAYROLL')">
      </i>
    </div>
  </div>
  <div class="grid-col-dept-dummy grid-col-dept-dummy-scroll payrollDept-bar"
       [ngClass]="buAccess.department === 'PAYROLL'?'d-none':''">
    <div class="pull-right grid-itm payroll-action timesheet-col-collapse">
      <i class=" fa fa-minus-square-o btn-pay-dept-collapse">
      </i>
    </div>
  </div>-->
      </ng-container>
    </ng-container>
  </div>
</ng-template>
